import { render } from "./AdmPagination.vue?vue&type=template&id=a54dc350&scoped=true"
import script from "./AdmPagination.vue?vue&type=script&lang=js"
export * from "./AdmPagination.vue?vue&type=script&lang=js"

import "./AdmPagination.vue?vue&type=style&index=0&id=a54dc350&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54dc350"]])

export default __exports__